import { ReactNode } from 'react';
import { ProtectedAdminRoute } from './ProtectedAdminRoute';

interface ProtectedDevFeatureRouteProps {
  children: ReactNode;
  /** true のとき認証済みユーザー全員がアクセス可（リリース後） */
  publicEnabled: boolean;
}

/**
 * 開発中機能のルート保護。publicEnabled が false のときは管理者のみ。
 */
export function ProtectedDevFeatureRoute({
  children,
  publicEnabled,
}: ProtectedDevFeatureRouteProps) {
  if (publicEnabled) {
    return <>{children}</>;
  }
  return <ProtectedAdminRoute>{children}</ProtectedAdminRoute>;
}
